import { render } from "./quotaDetailPage.vue?vue&type=template&id=c47cbf36&scoped=true"
import script from "./quotaDetailPage.vue?vue&type=script&lang=js"
export * from "./quotaDetailPage.vue?vue&type=script&lang=js"

import "./quotaDetailPage.vue?vue&type=style&index=0&id=c47cbf36&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c47cbf36"]])

export default __exports__